
import React from 'react';

const TestimonialsSlider: React.FC = () => {
  return (
    <div className="my-8">
      <div className="elfsight-app-8035415c-a9e5-4349-9f78-ed8ca14289af" data-elfsight-app-lazy></div>
    </div>
  );
};

export default TestimonialsSlider;
